import FolderButton from "./folder-button.jsx";
import {getIconByType, getIconColorByType, openLibraryFile} from "../utils/library-utils.js";
import LibraryDropzone from "./library-dropzone.jsx";
import {useCallback} from "react";
import {navigateHook} from "../../../../hooks/use-navigate.js";

export default function LibraryGrid({ items = [], isSearching = false, isLoading = false, isFetching = false, hasPermission, onOpenFolder, onDropFile, buttonOptions, selectedItemIds = [], onSelectItem }) {
    const navigate = navigateHook();

    const handleOpenItem = useCallback(async (item) => {
        if (!item) return;

        if (item.type === "FOLDER") {
            onOpenFolder(item);
            return;
        }

        if (item.type === "FILE") {
            await openLibraryFile(item);
            return;
        }

        if (item.type === "DOCUMENT") {
            navigate(`/library/document/form/${item.id}`, true);
        }
    }, [onOpenFolder, navigate]);

    return (
        <div
            className="h-[calc(100vh-196px)] w-full overflow-y-auto"
            onDragOver={(event) => {
                event.preventDefault();
                event.stopPropagation();
            }}
            onDrop={(event) => {
                event.preventDefault();
                event.stopPropagation();

                if (!onDropFile) return;

                onDropFile(event.dataTransfer.files);
            }}
        >
            {isLoading ? (
                <div className="flex h-full w-full items-center justify-center">
                    Carregando...
                </div>
            ) : items.length > 0 ? (
                <div className={`
                    h-full w-full transition-opacity duration-150
                    ${isFetching ? "opacity-70" : "opacity-100"}
                `}>
                    <div className="grid grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-4 px-8 pt-1 pb-2">
                        {items.map((item) => {
                            const Icon = getIconByType(item);
                            const iconColorClassName = getIconColorByType(item);

                            return (
                                <FolderButton
                                    key={item.id}
                                    item={item}
                                    name={item.name}
                                    icon={Icon}
                                    iconColorClassName={iconColorClassName}
                                    onOpen={() => handleOpenItem(item)}
                                    buttonOptions={buttonOptions}
                                    isSelected={selectedItemIds.includes(item.id)}
                                    onSelect={(event) => onSelectItem(item, event)}
                                />
                            )
                        })}
                    </div>
                </div>
            ) : (
                <LibraryDropzone
                    isSearching={isSearching}
                    onSelectFile={onDropFile}
                    hasPermission={hasPermission}
                />
            )}
        </div>
    )
}
